import React, { useEffect, useState, createRef } from 'react'
import styled from 'styled-components'
import qs, { stringify } from 'query-string'
import { useSelector } from 'react-redux'

import { MobileMenuButton } from '../../components/buttons/Buttons'
import Icon, { NavArrowIcon } from '../../components/icon/Icon'
import { Text, Link } from '../../components/topography'
import barChart from '../../styles/assets/sidebarIcons/barChart.svg'
import lightBulb from '../../styles/assets/sidebarIcons/lightBulb.svg'
import FramedLightBulb from '../../styles/assets/sidebarIcons/framedLightBulb.svg'
import mglassFrame from '../../styles/assets/sidebarIcons/mglassFrame.svg'
import mglassBars from '../../styles/assets/sidebarIcons/mglassBars.svg'
import squareArrow from '../../styles/assets/sidebarIcons/squareArrow.svg'
import HamburgerMenuClose from '../../styles/assets/sidebarIcons/hamburger_close.svg'
import barChartSelected from '../../styles/assets/sidebarIcons/barChartSelected.svg'
import lightBulbSelected from '../../styles/assets/sidebarIcons/lightBulbSelected.svg'
import FramedLightBulbSelected from '../../styles/assets/sidebarIcons/framedLightBulbSelected.svg'
import mglassFrameSelected from '../../styles/assets/sidebarIcons/mglassFrameSelected.svg'
import mglassBarsSelected from '../../styles/assets/sidebarIcons/mglassBarsSelected.svg'
import squareArrowSelected from '../../styles/assets/sidebarIcons/squareArrowSelected.svg'
import backlinkSelected from '../../styles/assets/sidebarIcons/backlinkSelected.svg'
import backlink from '../../styles/assets/sidebarIcons/backlink.svg'
import dashboard from '../../styles/assets/sidebarIcons/dashboard.svg'
import dashboardSelected from '../../styles/assets/sidebarIcons/dashboardSelected.svg'
import download from '../../styles/assets/sidebarIcons/download.svg'
import support from '../../styles/assets/sidebarIcons/support.svg'
import consulting from '../../styles/assets/sidebarIcons/consulting.svg'
import knowledgeBase from '../../styles/assets/sidebarIcons/knowledge_base.svg'
import ubersuggest from '../../styles/assets/sidebarIcons/ubersuggest.svg'
import trafficAnalyzer from '../../styles/assets/sidebarIcons/trafficAnalyzer.svg'
import seoAnalyzer from '../../styles/assets/sidebarIcons/seoAnalyzer.svg'
import settings from '../../styles/assets/sidebarIcons/settings.svg'
import paymentIcon from '../../styles/assets/sidebarIcons/payment.svg'
import competitor from '../../styles/assets/sidebarIcons/podium.svg'
import competitorSelected from '../../styles/assets/sidebarIcons/podiumSelected.svg'
import dollarIcon from '../../styles/assets/sidebarIcons/dollar.svg'
import suggestFeatureIcon from '../../styles/assets/sidebarIcons/suggest_feature.svg'
import {
  palette,
  mediaQueries,
  fonts,
  setOpacity,
} from '../../styles/variables'
import {
  translate,
  withLanguageRoutes,
  pushWithLanguageRoutes,
} from '../../utils/translation'
import { Desktop, SmallDesktop } from '../../utils/media'
import { getParentLocId, isGlobal } from '../../utils/locations'
import { shouldBlockFeature, isPaidUser } from '../../utils/freeVersionBlock'
import { detectSafari, isIOS, sendMessage } from '../../utils/functions'
import { AIWRITER_BASE_URL, getGoogleSignOutURL } from '../../utils/consts.mjs'
import GoogleSignIn from '../../components/buttons/GoogleSignIn'
import history from '../../history'
import SidebarProjectSelector from '../../components/selector/SidebarProjectSelector'
import {
  isEnterpriseAdmin,
  isEnterpriseUser,
  isSignedIn,
  signOut,
} from '../../utils/userAuth'
import {
  selectExtraHeaderHeight,
  selectUserSubscription,
} from '../../state/selectors'
import StartFreeTrialCTA from '../../components/panels/StartFreeTrialCTA'
import AppSelector from '../../components/selector/AppSelector'
import { openSuggestFeatureLink } from '../../utils/suggestFeature'

import NewFeatureTooltip from './NewFeatureTooltip'

const bottomMenu = [
  {
    name: 'account_billing_tab',
    baseUrl: '/settings/account_billing',
    icon: paymentIcon,
    selectedIcon: paymentIcon,
    width: 20,
  },
  {
    name: 'menu_consulting',
    baseUrl:
      'https://neilpatel.com/consulting/?utm_source=ubersuggest-app&utm_medium=ubersuggest&utm_term=consulting-sidebar&utm_content=sidebar&utm_campaign=us-mkt-campaign-sql-ubersuggest-consulting',
    type: 'direct',
    shouldBlock: true,
    icon: consulting,
    selectedIcon: consulting,
    isOpenNewTab: true,
    width: 23,
  },
  {
    name: 'support',
    baseUrl: 'https://ubersuggest.zendesk.com/hc/en-us/requests/new',
    type: 'direct',
    shouldBlock: true,
    icon: support,
    selectedIcon: support,
    isOpenNewTab: true,
    width: 20,
  },
  {
    name: 'knowledge_base',
    baseUrl: 'https://knowledgebase.neilpatel.com/',
    type: 'direct',
    icon: knowledgeBase,
    selectedIcon: knowledgeBase,
    isOpenNewTab: true,
    width: 18,
  },
  {
    name: 'suggest_feature',
    icon: suggestFeatureIcon,
    selectedIcon: suggestFeatureIcon,
    baseUrl: '/',
    width: 20,
    onClick: (location) => {
      if (!isSignedIn()) {
        const newSearchParams = stringify({
          action: 'suggest-feature',
        })
        const searchParams = location.search
          ? `${location.search}&${newSearchParams}`
          : `?${newSearchParams}`

        sendMessage('SHOW_AUTH', {
          next: `${location.pathname}${searchParams}`,
        })

        return
      }

      openSuggestFeatureLink()
    },
  },
]

const PrimaryUl = styled.ul({
  fontSize: '16px',
  fontFamily: fonts.primaryBold,
  padding: '0',
  margin: '0',
  [mediaQueries.smallDesktop]: {
    paddingBottom: 0,
  },
})

const AppSelectorWrapper = styled.div({
  width: '100%',
  padding: '12px 14px',
  borderBottom: `1px solid ${palette.lightGray50}`,
})

const ListGroup = styled.div(() => ({
  margin: '0',
  [mediaQueries.smallDesktop]: {
    margin: '0 0 8px 0',
  },
}))

const SidebarWrapper = styled.div((props) => ({
  height: `calc(100vh - 60px - ${props.extraHeaderHeight}px)`,
  flex: '0 0 220px',
  backgroundColor: palette.white,
  borderRight: `1px solid ${palette.lightGray70}`,
  zIndex: 'auto !important',
  overflowX: 'hidden',
  transition: 'flex 0.5s',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginBottom: `${isIOS() ? '20px' : 0}`,
  paddingBottom: `${isIOS() ? '20px' : 0}`,

  /* width */
  '::-webkit-scrollbar': {
    width: '4px',
  },

  /* Track */
  '::-webkit-scrollbar-track': {
    background: palette.lightGray,
  },

  /* Handle */
  '::-webkit-scrollbar-thumb': {
    width: '8px',
    background: palette.gray,
  },

  /* Handle on hover */
  '::-webkit-scrollbar-thumb:hover': {
    background: palette.darkGray50,
  },

  [mediaQueries.smallDesktop]: {
    padding: '60px 0',
    height: '100vh',
    position: 'absolute',
    top: 0,
    zIndex: '110 !important',
    width: props.collapsed ? '70%' : '0',
    maxWidth: props.collapsed ? '70%' : '0',
    transition: 'width 0.5s',
    display: 'block',
    boxSizing: 'border-box',
  },
  [mediaQueries.smallMobile]: {
    width: props.collapsed ? '80%' : '0',
    maxWidth: props.collapsed ? '80%' : '0',
  },
}))

const TitleLi = styled.li((props) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  listStyleType: 'none',
  color: props.expanded ? palette.orange : palette.darkGray,
  padding: props.mobile ? '12px 24px 12px 20px' : '12px 20px',
  textAlign: props.collapse ? 'center' : 'inherit',
  background: palette.lightGray20,
  margin: '8px 0',
  cursor: 'pointer',
}))

const SecondaryUl = styled.ul({
  padding: '0',
  margin: '12px 0',
  [mediaQueries.mobile]: {
    marginBottom: '10px',
  },
})

const ItemLiImgWrapper = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  padding: props.collapse ? '0' : '0 0 0 20px',
}))

const ItemLi = styled.li((props) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: props.collapse ? 'center' : 'inherit',
  listStyleType: 'none',
  textDecoration: 'none',
  height: '32px',
  fontSize: '14px',
  fontWeight: 'normal',
  color: palette.darkGray70,
  borderRight: props.active ? `3px solid ${palette.orange}` : 'none',
  ':hover': {
    '& .menu-text': {
      fontFamily: fonts.primaryMedium,
    },
  },
  '& .menu-text': {
    fontFamily: props.active ? fonts.primaryMedium : fonts.primary,
  },
}))

const ItemLiImg = styled.img((props) => ({
  margin: props.collapse ? '0' : '0 12px 0 0',
}))

const NavDivider = styled.div((props) => ({
  margin: props.mobile
    ? `${props.top || 0}px 20px ${props.bottom || 0}px`
    : '12px 0',
  height: 1,
  background: palette.lightGray50,
}))

const ItemA = styled.div({})

const ItemLiText = styled.div((props) => ({
  color: props.disabled ? palette.lightGray70 : palette.darkGray,
  display: 'block',
  fontSize: '14px',
  '& span': {
    ':first-child': {
      flex: '0 1',
      minWidth: '70px',
    },
    ':last-child': {
      flex: '1 0',
    },
  },
  '&.auth-text': {
    color: palette.darkGray50,
  },
}))

const NewText = styled.span(() => ({
  color: palette.orange,
  fontSize: '12px',
  marginTop: '-3px',
  marginLeft: '3px',
  flex: '0 1',
}))

const TitleLiText = styled.span(() => ({
  fontFamily: fonts.primaryMedium,
  display: 'inherit',
}))

const DarkBackground = styled.div({
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  background: setOpacity(palette.pureBlack, 0.5),
  zIndex: 104,
})

const GoogleSignInButton = styled(GoogleSignIn)({
  margin: '0 20px',
})

const MobileBottom = styled.div({
  [mediaQueries.smallDesktop]: {
    paddingBottom: detectSafari() ? '150px' : '50px',
  },
})

const MenuItem = ({
  mobile,
  sections,
  sectionName,
  pathName,
  menuPath,
  location,
  onToggleCollapse,
  ...props
}) => {
  const expanded = props.isOpenAlways
    ? location.pathname.indexOf(menuPath) > -1
    : props.expanded
  const [refs, setRefs] = useState([])

  useEffect(() => {
    if (!sections[sectionName]?.subsections?.length) return
    setRefs((prevRefs) =>
      Array(sections[sectionName].subsections.length)
        .fill()
        .map((_, i) => prevRefs[i] || createRef()),
    )
  }, [sectionName, sections])

  const getAiKeyword = ({ subsection, parsed, prefix }) => {
    if (subsection.getAiKeyword && parsed['ai-keyword']) {
      return parsed['ai-keyword']
    }

    return subsection.setAiKeyword
      ? sessionStorage.getItem(`keyword${prefix}`) || ''
      : ''
  }

  return (
    <ListGroup id={sectionName}>
      {(!sections[sectionName].hideName || mobile) && (
        <TitleLi
          expanded={expanded}
          onClick={() => {
            if (!props.isOpenAlways) {
              props.handleToggleMenu(sectionName)
              return
            }
            if (sections[sectionName]?.externalLink) {
              window.location.href = sections[sectionName].baseUrl
              return
            }
            if (location.pathname.indexOf(menuPath) < 0) {
              pushWithLanguageRoutes(menuPath)
            }
            props.handleCloseAllMenu()
            mobile && onToggleCollapse()
          }}
        >
          <TitleLiText>
            {translate(sectionName)}
            {props.isNew && <NewText>{translate('new')}</NewText>}
          </TitleLiText>
          {!props.isOpenAlways &&
            (props.expanded ? (
              <NavArrowIcon down color={palette.gray} />
            ) : (
              <NavArrowIcon right color={palette.gray} />
            ))}
        </TitleLi>
      )}
      {props.expanded && (
        <SecondaryUl>
          {sections[sectionName].subsections.map((subsection, index) => {
            return subsection.mobileOnly ? null : (
              <NewFeatureTooltip
                key={subsection.name}
                show={subsection.hasTooltip}
                content={subsection.tooltipContent}
                distance={subsection.tooltipDistance}
                refs={refs}
                index={index}
              >
                <ItemA id={subsection.name} ref={refs[index]}>
                  {!subsection.disabled && (
                    <Link
                      type={subsection.type}
                      to={(prevLocation) => {
                        const { queryType, queryPrefix } = subsection

                        const newQuery = {
                          ...(subsection.allowCityLocId
                            ? props.countryQuery
                            : props.query),
                        }

                        const prefix = queryPrefix ? `_${queryPrefix}` : ''
                        const domain = sessionStorage.getItem(`domain${prefix}`)
                        const parsed = qs.parse(window.location.search)
                        const keyword = sessionStorage.getItem(
                          `keyword${prefix}`,
                        )
                        const aiKeyword = getAiKeyword({
                          subsection,
                          parsed,
                          prefix,
                        })
                        const locId = sessionStorage.getItem(`locId${prefix}`)
                        const lang = sessionStorage.getItem(`lang${prefix}`)
                        const mode =
                          sessionStorage.getItem(`mode${prefix}`) ||
                          `domain${prefix}`

                        // Do not change url when user is currently in the same report.

                        if (
                          subsection.name !== 'dashboard' &&
                          prevLocation.pathname.indexOf(subsection.baseUrl) > -1
                        ) {
                          return `${prevLocation.pathname}${prevLocation.search}`
                        }
                        if (queryType === 'domain' && domain) {
                          newQuery.domain = domain
                          newQuery.mode = mode
                        } else if (queryType === 'keyword' && keyword) {
                          newQuery.keyword = keyword
                          if (aiKeyword) newQuery['ai-keyword'] = aiKeyword
                        } else if (queryType === 'both') {
                          if (keyword) {
                            newQuery.keyword = keyword
                            if (aiKeyword) newQuery['ai-keyword'] = aiKeyword
                          } else if (domain) {
                            newQuery.domain = domain
                            newQuery.mode = mode
                          }
                        }

                        if (locId) {
                          newQuery.locId = subsection.allowCityLocId
                            ? locId
                            : getParentLocId(locId)
                        }
                        if (lang) newQuery.lang = lang
                        if (isGlobal(newQuery.locId)) {
                          if (!subsection.allowGlobalLocation) {
                            newQuery.locId =
                              props.user?.preferences?.locId || '2840'
                            newQuery.lang =
                              props.user?.preferences?.lang || 'en'
                          }
                        }

                        return subsection.type === 'direct'
                          ? subsection.baseUrl
                          : withLanguageRoutes(
                              subsection.extraPath
                                ? `${subsection.baseUrl}${subsection.extraPath}`
                                : subsection.baseUrl,
                              subsection.skipQuery
                                ? ''
                                : `?${qs.stringify(newQuery, { sort: false })}`,
                            )
                      }}
                      target={subsection.isOpenNewTab ? '_blank' : null}
                      style={{ color: 'black' }}
                      onClick={(e) => {
                        if (
                          subsection.shouldBlock &&
                          shouldBlockFeature(
                            'sidebar',
                            'actions',
                            subsection.name,
                          )
                        ) {
                          e.preventDefault()
                          e.stopPropagation()
                          props.handleClickSupport()
                        }
                        mobile && onToggleCollapse()
                      }}
                    >
                      {subsection.isSeparated && (
                        <NavDivider mobile={mobile} top={12} bottom={12} />
                      )}
                      <ItemLi
                        active={
                          pathName.indexOf(
                            withLanguageRoutes(subsection.baseUrl),
                          ) > -1
                        }
                      >
                        <ItemLiImgWrapper>
                          <ItemLiText className="menu-text">
                            {translate(subsection.name)}
                            {subsection.isNew && (
                              <NewText>{translate('new')}</NewText>
                            )}
                          </ItemLiText>
                        </ItemLiImgWrapper>
                      </ItemLi>
                    </Link>
                  )}
                  {subsection.disabled && (
                    <div style={{ color: 'grey' }}>
                      <ItemLi>
                        <ItemLiImgWrapper>
                          <ItemLiText className="menu-text" disabled>
                            {translate(subsection.name)}
                            {subsection.isNew && (
                              <NewText>{translate('new')}</NewText>
                            )}
                          </ItemLiText>
                        </ItemLiImgWrapper>
                      </ItemLi>
                    </div>
                  )}
                </ItemA>
              </NewFeatureTooltip>
            )
          })}
        </SecondaryUl>
      )}
    </ListGroup>
  )
}

const BottomMenu = styled.div({
  background: palette.lightGray20,
  padding: '16px 0 60px',
  borderTop: `1px solid ${palette.lightGray50}`,
  [mediaQueries.mobile]: {
    background: 'transparent',
    border: `none`,
    padding: '16px 0 16px',
  },
})

const SideBarList = ({
  sections,
  isCollapsed,
  extraHeaderHeight,
  isLoadingProjects,
  projects,
  selectedProject,
  handleChangeProject,
  handleAddProject,
  handleEditProject,
  mobile,
  handleClickSupport,
  user,
  onToggleCollapse,
}) => {
  const [expandedMenu, setExpandedMenu] = useState('')
  const userSubscription = useSelector(selectUserSubscription())
  const query = qs.parse(history.location.search)
  let countryQuery = {}
  if (query.locId) {
    countryQuery = { ...query, locId: getParentLocId(query.locId) }
  }

  useEffect(() => {
    Object.keys(sections).forEach((sectionName) => {
      const foundSubsection = sections[sectionName].subsections?.find(
        (subsection) =>
          history.location.pathname.indexOf(subsection.baseUrl) > -1,
      )
      if (foundSubsection) {
        setExpandedMenu(sectionName)
      }
    })
  }, [sections])

  return (
    <SidebarWrapper
      collapsed={isCollapsed}
      extraHeaderHeight={extraHeaderHeight || 0}
    >
      <PrimaryUl data-testid="sidebar-list">
        <SmallDesktop>
          <AppSelectorWrapper>
            <AppSelector />
          </AppSelectorWrapper>
        </SmallDesktop>
        {!isLoadingProjects && (
          <SidebarProjectSelector
            align="right"
            projects={projects}
            selectedProject={selectedProject}
            onChangeProject={handleChangeProject}
            onAddProject={handleAddProject}
            onEditProject={handleEditProject}
            fullWidth
            style={{
              margin: 0,
              [mediaQueries.smallDesktop]: {
                width: '100%',
              },
            }}
          />
        )}
        {Object.keys(sections).map((sectionName) => {
          const expanded = expandedMenu === sectionName
          return (
            <MenuItem
              mobile={mobile}
              key={sectionName}
              sections={sections}
              sectionName={sectionName}
              handleClickSupport={handleClickSupport}
              pathName={history.location.pathname}
              expanded={expanded || sections[sectionName].expanded}
              isNew={sections[sectionName].isNew}
              isOpenAlways={sections[sectionName].isOpenAlways}
              menuPath={sections[sectionName].baseUrl}
              query={query}
              countryQuery={countryQuery}
              handleToggleMenu={(menu) => {
                if (expandedMenu === menu) {
                  setExpandedMenu('')
                } else {
                  setExpandedMenu(menu)
                }
              }}
              handleCloseAllMenu={() => setExpandedMenu('')}
              location={history.location}
              user={user}
              onToggleCollapse={onToggleCollapse}
            />
          )
        })}
      </PrimaryUl>
      {!isPaidUser() && !isEnterpriseUser() && !isEnterpriseAdmin() && (
        <StartFreeTrialCTA />
      )}

      {mobile && (
        <Link
          key="plans_pricing"
          to={withLanguageRoutes('/pricing')}
          style={{
            color: 'black',
            padding: '0 20px',
            marginTop: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <div
            style={{
              padding: '12px 15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              width: '100%',
              borderRadius: '35px',
              backgroundColor: palette.orange10,
            }}
          >
            <Icon
              src={dollarIcon}
              alt="Plans & Pricing"
              margin="0 10px 0 0"
              width={20}
            />
            <Text fontFamily={fonts.primaryBook} lineHeight="14px">
              {translate('plans_pricing')}
            </Text>
          </div>
        </Link>
      )}
      {mobile && <NavDivider mobile={mobile} top={24} />}
      <BottomMenu>
        {bottomMenu.map((subsection) => {
          return (
            <Link
              key={subsection.name}
              type={subsection.type}
              to={
                subsection.type === 'direct'
                  ? subsection.baseUrl
                  : withLanguageRoutes(subsection.baseUrl)
              }
              target={subsection.isOpenNewTab ? '_blank' : null}
              style={{ color: 'black' }}
              onClick={(e) => {
                if (subsection.name === 'suggest_feature') {
                  e.preventDefault()
                  e.stopPropagation()
                  subsection.onClick(history.location, userSubscription)
                }

                if (
                  subsection.name === 'account_billing_tab' &&
                  !isSignedIn()
                ) {
                  e.preventDefault()
                  e.stopPropagation()
                  sendMessage('SHOW_AUTH', { next: subsection.baseUrl })
                }
                if (
                  subsection.shouldBlock &&
                  shouldBlockFeature('sidebar', 'actions', subsection.name)
                ) {
                  e.preventDefault()
                  e.stopPropagation()
                  handleClickSupport()
                }
                mobile && onToggleCollapse()
              }}
            >
              <ItemLi>
                <ItemLiImgWrapper>
                  <div style={{ width: '35px' }}>
                    <ItemLiImg
                      src={subsection.icon}
                      alt=""
                      width={subsection.width}
                    />
                  </div>
                  <ItemLiText
                    className="menu-text"
                    disabled={!!subsection.disabled}
                  >
                    {translate(subsection.name)}
                    {subsection.isNew && <NewText>{translate('new')}</NewText>}
                  </ItemLiText>
                </ItemLiImgWrapper>
              </ItemLi>
            </Link>
          )
        })}
      </BottomMenu>

      {mobile && (
        <MobileBottom>
          <NavDivider mobile={mobile} bottom={16} />
          {isSignedIn() ? (
            <ItemA key="logout">
              <a
                href={`${getGoogleSignOutURL({
                  next: `${history.location.pathname}${history.location.search}`,
                })}`}
                style={{ color: 'black' }}
                onClick={() => {
                  signOut()
                }}
              >
                <ItemLi>
                  <ItemLiImgWrapper>
                    <ItemLiText className="menu-text auth-text">
                      {translate('sign_out')}
                    </ItemLiText>
                  </ItemLiImgWrapper>
                </ItemLi>
              </a>
            </ItemA>
          ) : (
            <GoogleSignInButton
              hideIcon
              useClickEvent
              redirectURL="/login"
              label={translate('sign_in')}
              height="34px"
              theme="dark"
            />
          )}
        </MobileBottom>
      )}
    </SidebarWrapper>
  )
}

const SideBar = ({
  collapsed,
  onToggleCollapse,
  user,
  handleClickSupport,
  ...rest
}) => {
  const extraHeaderHeight = useSelector(selectExtraHeaderHeight())
  const generateMenu = (type) => ({
    menu_general: {
      image: '',
      hideName: type === 'desktop',
      path: '',
      expanded: type === 'desktop',
      subsections: [
        {
          name: 'dashboard',
          baseUrl: '/dashboard',
          icon: dashboard,
          selectedIcon: dashboardSelected,
          skipQuery: true,
        },
        {
          name: 'rank_tracking',
          baseUrl: '/position_tracking',
          extraPath: '/recent',
          icon: settings,
          selectedIcon: settings,
          skipQuery: true,
        },
        {
          name: 'seo_opportunities',
          baseUrl: '/seo_opportunities',
          icon: settings,
          selectedIcon: settings,
          skipQuery: true,
        },
        {
          name: 'menu_workspace',
          baseUrl: '/workspace',
          icon: settings,
          selectedIcon: settings,
          skipQuery: true,
        },
        {
          name: 'menu_extension',
          baseUrl: '/extension',
          icon: download,
          selectedIcon: download,
        },
      ],
    },
    menu_seo_analyzer: {
      path: 'menu_seo_analyzer',
      baseUrl: '/seo_analyzer/site_audit',
      image: '',
      isOpenAlways: true,
    },
    menu_keyword_research: {
      path: 'ubersuggest',
      image: ubersuggest,
      subsections: [
        {
          name: 'menu_keyword_overview',
          baseUrl: '/ubersuggest/overview',
          icon: barChart,
          selectedIcon: barChartSelected,
          allowCityLocId: true,
          allowGlobalLocation: true,
          queryType: 'keyword',
          setAiKeyword: true,
        },
        {
          name: 'menu_keyword_ideas',
          baseUrl: '/ubersuggest/keyword_ideas',
          icon: lightBulb,
          selectedIcon: lightBulbSelected,
          allowCityLocId: true,
          allowGlobalLocation: true,
          queryType: 'both',
          setAiKeyword: true,
        },
        {
          name: 'menu_keyword_visualization',
          baseUrl: '/ubersuggest/keyword_visualization',
          icon: lightBulb,
          selectedIcon: lightBulbSelected,
          allowCityLocId: true,
          allowGlobalLocation: true,
          queryType: 'both',
          queryPrefix: 'visual',
        },
        {
          name: 'menu_keywords_traffic',
          baseUrl: '/traffic_analyzer/keywords',
          icon: mglassBars,
          selectedIcon: mglassBarsSelected,
          queryType: 'domain',
        },
        {
          name: 'menu_similar_websites',
          baseUrl: '/traffic_analyzer/competitors',
          icon: competitor,
          selectedIcon: competitorSelected,
          queryType: 'domain',
        },
        {
          name: 'menu_content_ideas',
          baseUrl: '/ubersuggest/content_ideas',
          icon: FramedLightBulb,
          selectedIcon: FramedLightBulbSelected,
          queryType: 'keyword',
          setAiKeyword: true,
        },
        {
          name: 'menu_keyword_lists',
          baseUrl: '/ubersuggest/keyword_lists',
          icon: lightBulb,
          selectedIcon: lightBulbSelected,
          allowCityLocId: true,
          isSeparated: true,
          queryType: 'keyword',
        },
      ],
    },
    menu_traffic_estimation: {
      path: 'traffic_analyzer',
      image: trafficAnalyzer,
      subsections: [
        {
          name: 'menu_traffic_overview',
          baseUrl: '/traffic_analyzer/overview',
          icon: mglassFrame,
          selectedIcon: mglassFrameSelected,
          queryType: 'domain',
        },
        {
          name: 'menu_top_pages_traffic',
          baseUrl: '/traffic_analyzer/top_pages',
          icon: squareArrow,
          selectedIcon: squareArrowSelected,
          queryType: 'domain',
        },
      ],
    },
    menu_backlinks: {
      path: 'seo_analyzer',
      image: seoAnalyzer,
      subsections: [
        {
          name: 'menu_backlinks_overview',
          baseUrl: '/seo_analyzer/backlinks',
          icon: backlink,
          selectedIcon: backlinkSelected,
          queryType: 'domain',
        },
        {
          name: 'backlink_opportunity',
          baseUrl: '/seo_analyzer/backlink_opportunity',
          icon: backlink,
          selectedIcon: backlinkSelected,
          queryType: 'domain',
        },
      ],
    },
    menu_labs: {
      path: 'menu_labs',
      baseUrl: '/labs/landing',
      image: '',
      isOpenAlways: false,
      subsections: [
        {
          name: 'menu_labs',
          baseUrl: '/labs/landing',
          icon: download,
          selectedIcon: download,
          queryType: 'keyword',
        },
        {
          name: 'keywords_generator',
          baseUrl: '/labs/keywords_generator',
          icon: download,
          selectedIcon: download,
          queryType: 'keyword',
        },
      ],
    },
    ai_writer: {
      path: 'menu_aiwriter',
      baseUrl: AIWRITER_BASE_URL,
      externalLink: true,
      image: '',
      isOpenAlways: true,
    },
  })
  return (
    <>
      <SmallDesktop>
        {collapsed && <DarkBackground />}
        {collapsed && (
          <MobileMenuButton
            styles={{
              [mediaQueries.smallDesktop]: {
                top: '17px',
                zIndex: 999,
              },
            }}
            onClick={onToggleCollapse}
          >
            <Icon size={22} src={HamburgerMenuClose} />
          </MobileMenuButton>
        )}
      </SmallDesktop>
      <SmallDesktop>
        <SideBarList
          {...rest}
          mobile
          sections={generateMenu('mobile', user)}
          isCollapsed={collapsed}
          handleClickSupport={handleClickSupport}
          onToggleCollapse={onToggleCollapse}
          user={user}
        />
      </SmallDesktop>
      <Desktop minWidth={1281}>
        <SideBarList
          {...rest}
          sections={generateMenu('desktop', user)}
          isCollapsed={collapsed}
          handleClickSupport={handleClickSupport}
          onToggleCollapse={onToggleCollapse}
          user={user}
          extraHeaderHeight={extraHeaderHeight}
        />
      </Desktop>
    </>
  )
}
export default SideBar
